<template>
  <div class="w-full lg:w-1/3 h-full flex flex-col order-first sm:order-none">
    <div class="hidden lg:block px-4 py-2 rounded" :class="activeColorClass">
      <h2 class="flex items-center whitespace-nowrap lg:whitespace-normal">
        <span
          class="text-xl font-bold max-w-[70%] overflow-hidden text-ellipsis"
          :title="`En cours à mon niveau: ${store.home.current.total} parapheurs`"
        >
          En cours à mon niveau : {{ store.home.current.total }}
        </span>
        <span
          v-if="store.home.current.draft"
          class="ml-auto max-w-[30%] overflow-hidden text-ellipsis"
          :title="`${store.home.current.draft} brouillon${store.home.current.draft > 1 ? 's' : ''}`"
        >
          + {{ store.home.current.draft }} brouillon{{ store.home.current.draft > 1 ? "s" : "" }}
        </span>
      </h2>
    </div>
    <ul class="bg-grey-950 p-1 rounded lg:mt-1 flex flex-col gap-1 overflow-y-scroll">
      <li v-for="letterFile in letterFiles" :key="letterFile.id">
        <LetterFile
          :letter-file="letterFile"
          current
          @select="toggleMassSignSelect(letterFile.id)"
          :selected="massSignatureStore.selectedLetterFiles.includes(letterFile.id)"
        />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import LetterFile from "../../components/LetterFile.vue";
import { useLetterFileStore } from "../../stores/letter-file.store";
import { useLetterFileColor } from "../../composable/useLetterFileColor";
import { useMassSignatureStore } from "../../stores/mass-signature.store";
import { useMassSign } from "../../composable/use-mass-sign";

const store = useLetterFileStore();
const massSignatureStore = useMassSignatureStore();
const { activeColorClass } = useLetterFileColor();

const letterFiles = computed(() => store.home.current.data);

const { toggleMassSignSelect } = useMassSign();
</script>
